import { TaskDto } from '@/api/generated';

export enum TaskSortType {
  NEW = 'new',
  OLD = 'old'
}

export const sortTasks = (tasks: TaskDto[], sortType: TaskSortType) => {
  if (sortType === TaskSortType.OLD) {
    return tasks.sort((a, b) =>
      a.createdAt && b.createdAt
        ? new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        : 0
    );
  } else {
    return tasks.sort((a, b) =>
      a.createdAt && b.createdAt
        ? new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        : 0
    );
  }
};
